export default __webpack_public_path__ + "static/media/office1-before1-2048w.67e051b4.avif";